/*
 * @Author: hao.chen
 * @Date: 2024-11-28 
 */
import axios from "axios";
import router from '~/router/router'
import { getAcceptLanguageHeader } from '~/i18n'
// 创建实例
const service = axios.create({
  timeout: 1000000
})

// 暂时使用测试环境
// let devPrefix = 'https://api.st1.artemisads.com';
let devPrefix = '';
let prefix = '';
if (location.origin.indexOf('admaads') !== -1) {
  prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('admaads', 'apiaads') : devPrefix;
} else {
  prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('adm', 'api') : devPrefix;
}

/**
 * 添加请求拦截器
 */
service.interceptors.request.use(
  config => {
  if(config.isV2) {
      config.url = prefix + '/admin/artemisads/v2/' + config.url;
    }else{
  if (config.url.indexOf('/api/storage') === -1) {
      config.url = prefix + '/admin/artemisads/v1/' + config.url;
    }
    }
    const localStoragePrefix = location.hostname;
    const userToken = localStorage.getItem(`${localStoragePrefix}_userToken`);
    // const userToken = 'eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiIzNTU1OTdiYjQ5Nzg3YzJkIiwiaXNzIjoid3d3LmFydGVtaXNhZHMuY29tIiwic3ViIjoic2h1Y3VuYmluIiwiZXhwIjoxNzMzMzg4MDM1LCJpYXQiOjE3MzMxMjg4MzUsInRva2VuVmVyc2lvbiI6NiwibmFtZSI6InNodWN1bmJpbiIsImlkIjoyLCJyb2xlTmFtZXMiOlsiUk9MRV9TWVNURU1fQURNSU4iXSwiZW1haWwiOiJzaHVjdW5iaW5fdGVzdEBhcnRlbWlzYWRzLmNvbSIsInN0YXR1cyI6Ik5PUk1BTCJ9.UDp-cpde6IdQh7AQUtQ8UbqMa5tLV4zw5OXSyDYrGn4TqU_s-WM6Og-66ElFe67_OwRtH6aR8XY9vyaurR0J9A';
    config.headers['Accept-Language'] = `en-US`;
    if (userToken) {
      config.headers['x-aa-admin-authorization'] = `Bearer ${userToken}`;
    }
    return config;
  },
  error => {
    //请求错误时做些事
    return Promise.reject(error);
  }
);

// formdata upload
const formatRequestConfigFormData = (config) => {
    const localStoragePrefix = location.hostname
    const userToken = localStorage.getItem(`${localStoragePrefix}_userToken`);
    config.headers['Authorization'] = userToken;
    config.headers['Accept-Language'] = getAcceptLanguageHeader();
    return config;
};

const err = (response) => {
    if (!response) {
      console.error('网络开小差啦');
    } else {
      const { status } = response.response;
      switch (status) {
        case 403:
          // 处理403
          break;
        case 401:
          // router.push({path: '/login', query: {redirect: location.hostname }});
          break;
        case 400:
          if (!response.config.ignoreError) {
            // 显示错误信息
          }
          break;
        case 999:
          // window.location.href = window.location.origin + '/login';
        default:
          break;
      }
    }
    return Promise.reject(response);
  };

service.interceptors.response.use(response => {
  const extendedResponse = response;
  const res_data = response.data;
  if (extendedResponse) {
    switch (extendedResponse.status) {
      case 401:
        router.push({path: '/operator/login', query: {redirect: location.hostname }});
    }
  }
  if (!res_data.success) {
    console.log(res_data.error || 'Error!')
  }
  if(res_data.code === '3010') {
    console.error('Authentication token does not match');
    router.replace('/operator/login');
    return;
  } else if (res_data.code === '3006') {
    console.error(res_data.error || 'Authorization header is missing');
    router.replace('/operator/login');
    return;
  }
  return Promise.resolve(res_data);
});

const formDataAxios = axios.create({
    baseURL: 'api/',
    timeout: 20000,
    headers: {
      'Content-Type': 'multipart/form-data',
      // 'Authorization': store.state.token
    }
  });
  
formDataAxios.interceptors.request.use(formatRequestConfigFormData, err);

export {
    service as axios,
    formDataAxios as formDataAxios
};
